const capitalize = (s: string): string => {
  const subs = s.split(" ");
  if (subs.length <= 1) {
    return s.charAt(0).toLocaleUpperCase() + s.slice(1).toLocaleLowerCase();
  } else {
    return subs.map(capitalize).join(" ");
  }
};

export const enumToReadable = (s: string): string => {
  return capitalize(s.replace(/\_/g, " "));
};

export const truncateSentence = (s: string, maxChars: number): string => {
  return s.slice(0, maxChars).replace(/[^\ ]+$/, "");
};
